/**
 * @heading1: Image Class
 * @paragraph: This class provides static references to image assets used in the application.
 * It helps in managing and accessing images in a centralized way.
 */

class ImageClass {
    /**
     * @heading3: Dark Logo
     * Reference to the dark version of the logo.
     * @type {string} - Path to the 'logo-dark.png' image.
     */
    static logoDark = require('./logo-dark.png');
    /**
    * @heading3: Light Logo
    * Reference to the light version of the logo.
    * @type {string} - Path to the 'logo-light.png' image.
    */
    static logoLight = require('./logo-light.png');
    static userImage = require('./user.jpg');
    static domain = require('./domain.png');
    static document = require('./document.png');
    static userPlacedholder = require('./user.png');
    static userProfile = require('./user_profile.jpg');
    static noActivity = require('./no_activity.png');
    // static noPipelineStage = require('./pipeline_1.png');
    static outlookLogo = require('./outlook-logo.png');
    static googleCalendarLogo = require('./google-calendar-logo.png');
    static calendar = require('./calendar.png');
    static stripeLogo = require('./stripe-logo.png');
    static emailIntegration = require('./gmail-logo.png');
    static twilioLogo = require('./twilio-logo.jpg');
    static googleLogo = require('./google-logo.png');
    static googleFullNameLogo = require('./google-full-logo.png');
    static googleMeetLogo = require('./google-meet-logo.png');
    static customerSignup = require('./customer_singup.png');
    static auth = require('./auth.png');
    static emptyPipeline = require('./empty_pipeline.png');
    static stripeFullNameLogo = require('./stripe-full-logo.png');
    static starterImage = require('./starter.png');
    static growthImage = require('./growth.png');
    static facebookLogo = require('./facebook-logo.png');
    static noEmail = require('./no_email.png');
    static noForm = require('./no_form.png');
    static noPhoneConversation = require('./no_phone_conversation.png');
    static smtpLogo = require('./smtp_logo.png');
    static elementorLogo = require('./elementor.png');
    static snappsLogo = require('./snapps.png');
    static customLogo = require('./custom.png');
}

export default ImageClass;